const metricIndicators = [2, 14, 3, 1];
const statuses = ['up', 'down'];

function generateRandomIpAddress() {
  const ipAddressSegments = [];
  for (let i = 0; i < 4; i += 1) {
    ipAddressSegments.push(Math.floor(Math.random() * 256));
  }
  return ipAddressSegments.join('.');
}

function generateRandomEquipment() {
  return {
    id: Math.floor(Math.random() * 100),
    name: `Equipment ${Math.floor(Math.random() * 100)}`
  }
}

function generateRandomObject() {
  return {
    status: metricIndicators[Math.floor(Math.random() * metricIndicators.length)],
    interface: `Interface ${Math.floor(Math.random() * 100)}`,
    status_oper: statuses[Math.floor(Math.random() * statuses.length)],
    status_admin: statuses[Math.floor(Math.random() * statuses.length)],
    bandwidth: `${Math.floor(Math.random() * 100)} Mbps`,
    ipAddress: generateRandomIpAddress(),
    description: 'Mock Description',
    equipments: Array.from({ length: 5 }, generateRandomEquipment),
  };
}

const arrayOfObjects = Array.from({ length: 20 }, generateRandomObject);

export default arrayOfObjects;
